module.exports = __webpack_public_path__ + "img/tou4.2fab4c2c.jpg";